import { FC, ReactElement } from 'react'

import { formatDate } from '../../../../../helpers/date'
import { Icon } from '../../../../components'
import { ElementWithTooltip } from '../../../../compositions'
import { getDepartmentLabel } from '../../../../entities/Department/DepartmentHelpers'
import { Period } from '../../../../entities/Period/Period'
import { TrackShift } from '../../../../entities/Shift/Shift'
import trans from '../../../../helpers/trans'
import { DateFormat } from '../../../../types/dateFormatTypes'

import './UserShiftTrackTime.scss'

interface UserShiftTrackTimeProps {
    isOrphan?: boolean;
    trackShift?: TrackShift;
    shiftPeriod?: Period;
    trackPeriod?: Period;
    className?: string;
}

const UserShiftTrackTime: FC<UserShiftTrackTimeProps> = ({
    isOrphan,
    trackShift,
    shiftPeriod,
    trackPeriod,
    className = '',
}): ReactElement => {
    const shiftStartTime = shiftPeriod ? formatDate(shiftPeriod.start, DateFormat.hoursMinutes) : undefined
    const shiftEndTime = shiftPeriod ? formatDate(shiftPeriod.end, DateFormat.hoursMinutes) : undefined
    const trackStartTime = trackPeriod ? formatDate(trackPeriod.start, DateFormat.hoursMinutes) : undefined
    const trackEndTime = trackPeriod ? formatDate(trackPeriod.end, DateFormat.hoursMinutes) : undefined

    return (
        <div className={`user-shift-track-time ${className}`}>
            {shiftPeriod ? (
                <div className="user-shift-track-time__time">
                    {`${shiftStartTime} - ${shiftEndTime}`}
                </div>
            ) : (
                <div className="user-shift-track-time__text">
                    {trans('common.unplanned')}

                    {(isOrphan && trackShift) && (
                        <ElementWithTooltip
                            tooltipIsActive
                            tooltipText={trans('compositions.userShiftTrackTime.orphanTrackTooltipLabel', {
                                department: trackShift.department
                                    ? getDepartmentLabel(trackShift.department)
                                    : '',
                            })}
                        >
                            <Icon
                                name="info-circle"
                                className="user-shift-track-time__special-day-icon"
                            />
                        </ElementWithTooltip>
                    )}
                </div>
            )}

            {trackPeriod && (
                <div className="user-shift-track-time__track-time">
                    {`${trackStartTime} - ${trackEndTime}`}
                    <Icon name="clock-outline" className="user-shift-track-time__icon" />
                </div>
            )}
        </div>
    )
}

export default UserShiftTrackTime
